<template>
  <div class="stage">
    <div class="gift" v-if="true || (result.result !== 'success' && gift.status !== 3)">
      <img class="gift-bg" :src="require(`../assets/images/gift-${typeName}-bg.png`)" @click.prevent/>
      <img class="gift-title" :src="require(`../assets/images/gift-${typeName}-title.png`)"/>
      <img class="gift-letter" :src="require(`../assets/images/gift-letter.png`)" @click.prevent/>
      <img class="gift-top" :src="require(`../assets/images/gift-${typeName}-top.png`)" @click.prevent/>
      <img class="gift-bottom" :src="require(`../assets/images/gift-${typeName}-bottom.png`)" @click.prevent/>

      <p class="gift-content">
        <letter :type="1" :price="gift.price || 0" :title="gift.title"/>
      </p>

      <p class="gift-sign">
        你的{{ typeNameCn }}: <img :src="gift.userPic" alt="avatar"/> {{ gift.userName }}
      </p>

      <div v-if="gift.status === 3"
        :class="`gift-operate ${typeName}`">
          已领取
      </div>
      <div v-else>
        <div v-if="gift.isSelf" :class="`gift-operate ${typeName}`" @click="give">立即赠送</div>
        <div v-else :class="`gift-operate ${typeName}`" @click="receive">立即领取</div>
      </div>

      <!-- <div v-if="gift.isSelf" :class="`gift-operate ${typeName}`" @click="give">
        立即赠送
      </div>
      <div v-else>
        <div v-if="gift.status === 3"
          :class="`gift-operate ${typeName}`">
          已领取
        </div>
        <div v-else :class="`gift-operate ${typeName}`" @click="receive">
          立即领取
        </div>
      </div> -->

      <give-success v-if="popup" confirmEvent="confirm" beginEvent="begin" @confirm="confirm" @begin="begin"/>
    </div>

    <!-- <received v-if="gift.status === 3 || result.result === 'success'" :type="resultType" :start="result.startDate" :end="result.endDate" eventName="operation" @operation="operation"/> -->
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/gift'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ShareMaker from '../lib/shareMaker'
import login from '@/utils/login'
import api from '@edu-fe/api'

import GiveSuccess from '../components/Gift/GiveSuccess'
import Letter from '../components/Gift/Letter'
import Received from '../components/Gift/Received'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters)),

    resultType () {
      if (this.result.result === 'success') {
        return 1
      } else if (this.gift.status === 3) {
        return 2
      }

      return 0
    }
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),

    operation () {
      if (this.result.result === 'success') {
        this.$router.push({ name: 'schedule', query: { courseId: this.gift.courseId } })
      } else {
        this.$router.push({ name: 'sign-up', query: { courseId: this.gift.courseId } })
      }
    },

    setWxConfig () {
      const href = `${location.protocol}//${location.host}${this.$route.fullPath}`
      /* eslint-disable */
      new ShareMaker({
        title: this.gift.title,
        introduction: '成功并不是旅途终点，而是旅行的过程，发现一门好课赠予你。',
        link: location.href,
        imgUrl: this.gift.courseImage
      }, location.href, true)
      /* eslint-enable */
    }
  },

  watch: {
    ready (n) {
      if (n) {
        this.$loading.hide()
      }

      // if (this.isWeixin) {
      //   // window.history.replaceState({}, document.title, this.landingPage)
      //   const href = `${location.protocol}//${location.host}${this.$route.fullPath}`

      //   /* eslint-disable */
      //   new ShareMaker({
      //     title: this.gift.title,
      //     introduction: '成功并不是旅途终点，而是旅行的过程，发现一门好课赠予你。',
      //     link: location.href,
      //     imgUrl: this.gift.courseImage
      //   }, location.href, true)
      //   /* eslint-enable */
      // }
    },

    popup_copy_href (n) {
      if (n) {
        const d = this.$dialog({
          title: '赠送好友',
          text: '请复制以下链接发送给好友：\n\r' + location.href,
          buttons: [{
            text: '确认',
            handler () {
              d.close()
            }
          }]
        })
      }
    }
  },

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  created () {
    login.login()
  },

  beforeDestroy () {
    // 关闭
    if (this.shareComponent) {
      this['removeShareComponent']()
    }
    this.$store.unregisterModule(module.name)
  },

  components: {
    GiveSuccess,
    Letter,
    Received
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";

@font-face {
  font-family: "letter font";
  src: url(../assets/fonts/gift-font.TTF);
}

$global-width: 750;

section {
  z-index: 999!important;

  div {
    word-break: break-all;
  }
}

.stage {
  height: 100%;
  width: 100%;
}

.gift {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  &-bg {
    height: 100%;
    width: 100%;
  }

  &-title {
    position: absolute;
    top: rem(42);
    left: 0; right: 0;
    margin: 0 auto;
    width: rem(647);
  }

  &-letter {
    position: absolute;
    top: rem(112);
    left: 0; right: 0;
    margin: 0 auto;
    z-index: 99;
    height: rem(1014);
    width: rem(638);
  }

  &-top {
    position: absolute;
    right: 0;
    top: rem(-110);
    height: rem(300);
    width: rem(300);
  }

  &-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    height: rem(300);
    width: rem(280);
  }

  &-content {
    position: absolute;
    top: rem(406);
    left: rem(156);
    z-index: 999;
    height: rem(232);
    width: rem(480);
    color: #687992;
    font-size: rem(32);
    font-family: 'letter font';
    line-height: rem(58);
  }

  &-sign {
    position: absolute;
    top: rem(761);
    right: rem(140);
    z-index: 999;
    color: #687992;
    font-size: rem(24);
    font-family: 'letter font';
    line-height: rem(26);

    img {
      height: rem(50);
      width: rem(50);
      line-height: rem(26);
      background-color: #dfdfdf;
      border-radius: 50%;
      vertical-align: middle;
      margin: 0 rem(10);
    }
  }

  &-operate {
    position: absolute;
    top: rem(995);
    left: 0; right: 0;
    margin: 0 auto;
    z-index: 999;
    width: rem(220);
    height: rem(64);
    line-height: rem(64);
    color: #fff;
    text-align: center;
    font-size: rem(32);
    font-family: 'letter font';
    // line-height: rem(35);
    text-shadow: 0 rem(2) rem(1) rgba(0,0,0,.2);

    @media screen and (min-width: 768px) {
      top: rem(850);
    }

    &.friend {
      background-image: linear-gradient(-180deg, #DBBF6F 3%, #BB8944 98%);
      box-shadow: 0 3px 0 0 #E3C475, inset 0 3px 5px 0 rgba(101,57,0,0.47);
      border-radius: 3px;
    }

    &.workmate {
      background-image: linear-gradient(-180deg, #638ED8 0%, #546997 100%);
      box-shadow: 0 3px 0 0 #93B5EF, inset 0 3px 7px 0 #4964A1;
      border-radius: 3px;
    }

    &.theOne {
      background-image: linear-gradient(-180deg, #F16873 0%, #DC555C 100%);
      box-shadow: 0 3px 0 0 rgba(255,99,99,0.50), inset 0 3px 4px 0 rgba(121,54,26,0.47);
      border-radius: 3px;
    }
  }
}
</style>
